import { Progress } from "antd";
import { notification } from "antd";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import Dropzone from "react-dropzone";
import { useOutletContext } from "react-router-dom";
import shortUUID from "short-uuid";

import { mediaUploadLimit, nameValidator } from "../../../constants/phase";
import { getPreAssignedUrl } from "../../../store/videogrid/api";
import { UploadIconBorder } from "../../icons";
function PreSignedUpload(props) {
  const {
    storageId,
    acceptFileType,
    isResourceBucket,
    callBackFun,
    progress,
    storage_name,
    setProgress,
    uploadingFileSize,
    setDisableEdit,
    fileType,
    setUploadFilesLength,
    uploadFilesLength,
    setTotalFilesSize,
    totalFilesSize,
    component,
    setFieldValue,
    setUploading,
    uploading,
    openDropZone,
    fileProgress,
  } = props;
  const { entityId } = useOutletContext();
  const [isMaxSizeShowMessage, setIsMaxSizeShowMessage] = useState({});
  const [uploadCount, setUploadCount] = useState(0);
  const uploadFilesRef = useRef([]);

  const uploadSize = uploadingFileSize * 1024 * 1024;

  const resetProperties = () => {
    setIsMaxSizeShowMessage({});
    setUploading(false);
    setProgress(0);
    uploadFilesRef.current.length = 0;
  };

  const onUpload = async (files) => {
    resetProperties();
    await Promise.all(
      files.map(async (item) => {
        if (!_.isEmpty(item)) {
          setUploading(true);
          let name = shortUUID().generate().substring(0, 8);
          const _file = item;
          name = (name + _file?.name?.replace(/ +/g, "")).replace(/[{()}]/g, "").replace(/[^a-zA-Z0-9_.]/g, "");
          setDisableEdit(true);
          let status = await getPreSignedUrlFun(name, _file.type, _file);
          return status ? item : null;
        } else {
          return null;
        }
      }),
    );
    setUploading(false);
    setUploadCount((prev) => prev + 1);
  };

  useEffect(() => {
    if (uploadCount > 0) {
      let tempUploadFileData = uploadFilesRef.current.map((filesContent) => {
        return {
          fileType: filesContent.uploadUrlData?.fileToUpload?.type.split("/")[0],
          isAudio: false,
          fileSize: filesContent.uploadUrlData?.fileToUpload?.size,
          uploadFileUrl: filesContent.uploadUrlData?.s3Url,
          uploadUrlTitle: nameValidator(filesContent.uploadUrlData?.fileToUpload?.name.split(".")[0]),
          fileName: nameValidator(filesContent.uploadUrlData?.fileToUpload?.name),
        };
      });
      callBackFun(tempUploadFileData);
      let tempFilesLength =
        component === "sound" || component === "thumbnailLogo" || !uploadFilesLength
          ? parseInt(uploadFilesRef.current.length)
          : parseInt(uploadFilesLength + uploadFilesRef.current.length);
      handleUploadFunc(tempUploadFileData, tempFilesLength);
    }
  }, [uploadCount]);

  const getPreSignedUrlFun = async (fileName, fileType, file) => {
    return new Promise(async (resolve) => {
      let data = {
        userId: localStorage.getItem("__uid"),
        entityId: entityId,
        resourceBucket: isResourceBucket,
        fileName: fileName,
        contentType: fileType,
        storage_name,
        storageId,
      };
      let value = await getPreAssignedUrl(data);
      if (value.success) {
        return resolve(uploadToS3(value.s3Url, value.presignedUrl, file));
      } else {
        resetProperties();
        setIsMaxSizeShowMessage({ message: `Could you kindly re-upload the file ${file.name}?` });
        return resolve(false);
      }
    });
  };

  const uploadToS3 = async (s3Url, presignedUrl, fileToUpload) => {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      fileProgress.current.xhrs.push(xhr);
      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          fileProgress.current.files[fileToUpload.name] = {
            loaded: 0,
          };
          fileProgress.current.files[fileToUpload.name].loaded = event.loaded;
          const totalLoaded = Object.values(fileProgress.current.files).reduce((acc, file) => acc + file.loaded, 0);
          const progressPercent = Math.round((totalLoaded / fileProgress.current.totalSize) * 100);
          setProgress(progressPercent);
        }
      });

      xhr.open("PUT", presignedUrl, true);
      xhr.setRequestHeader("Content-Type", fileToUpload.type);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            uploadFilesRef.current.push({
              uploadUrlData: { s3Url, fileToUpload },
            });
            return resolve(true);
          } else {
            resetProperties();
            fileProgress.current = {
              files: {},
              totalSize: fileProgress.current.totalSize - fileToUpload.size,
              xhrs: [],
            };
            notification["error"]({
              message: `The upload of the file (${fileToUpload.name}) was unsuccessful. Please re-upload the file`,
            });
            return resolve(false);
          }
        }
      };
      xhr.send(fileToUpload);
    });
  };

  const uploadFiles = (acceptedFiles) => {
    try {
      let filesCount = !uploadFilesLength
        ? parseInt(acceptedFiles.length)
        : parseInt(uploadFilesLength + acceptedFiles.length);
      let acceptedFilesSize = 0;
      let incorrectFileSize = false;
      let incorrectFileType = false;

      acceptedFiles.forEach((item) => {
        if (item.size > uploadSize) {
          incorrectFileSize = true;
        }
        if (!fileType.includes(item.type.split("/")[1].toLowerCase())) {
          incorrectFileType = true;
        }
        acceptedFilesSize = acceptedFilesSize + item.size;
      });

      fileProgress.current.totalSize = acceptedFilesSize;

      if (!incorrectFileType) {
        if (!incorrectFileSize) {
          if ((totalFilesSize ? totalFilesSize - acceptedFilesSize : acceptedFilesSize) >= 0) {
            switch (fileType[1]) {
              case "mov":
                if (filesCount <= mediaUploadLimit.overlayLimit) {
                  onUpload(acceptedFiles);
                } else {
                  notification["error"]({
                    message: `Only ${mediaUploadLimit.overlayLimit} files are allowed at a time.`,
                  });
                }
                break;
              case "jpg":
              case "png":
              case "jpeg":
                if (filesCount <= mediaUploadLimit.graphicsLimit) {
                  onUpload(acceptedFiles);
                } else {
                  notification["error"]({
                    message: `Only ${mediaUploadLimit.graphicsLimit} files are allowed at a time.`,
                  });
                }
                break;
              case "mp4":
              case "octet-stream":
                if (filesCount <= mediaUploadLimit.bumpersLimit) {
                  onUpload(acceptedFiles);
                } else {
                  notification["error"]({
                    message: `Only ${mediaUploadLimit.bumpersLimit} files are allowed at a time.`,
                  });
                }
                break;
              case "mp3":
              case "mpeg":
                if (filesCount <= mediaUploadLimit.soundLimit) {
                  onUpload(acceptedFiles);
                } else {
                  notification["error"]({
                    message: `Only ${mediaUploadLimit.soundLimit} files are allowed at a time.`,
                  });
                }
                break;
              default:
                notification["error"]({ message: "Only 10 files are allowed at a time." });
            }
          } else {
            notification["error"]({ message: "Total file size cannot exceed 400 MB." });
          }
        } else {
          setIsMaxSizeShowMessage({ message: `File size should not exceed ${uploadingFileSize}MB.` });
        }
      } else {
        setIsMaxSizeShowMessage({ message: `Only allows files in the ${fileType.toString()} format.` });
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const handleUploadFunc = async (filesContent, totalFilesLength) => {
    await Promise.all(
      filesContent.map((item) => {
        if (totalFilesLength > 1) {
          setFieldValue(`uploadUrl_${item.fileName}`, item.uploadFileUrl);
          setFieldValue(`title_${item.fileName}`, item.fileName);
        } else {
          setFieldValue(`uploadUrl`, item.uploadFileUrl);
          setFieldValue(`title`, item.fileName);
        }
      }),
    );
    if (uploadFilesRef.current && uploadFilesRef.current.length !== 0) {
      setTotalFilesSize(
        totalFilesSize -
          uploadFilesRef.current.reduce((acc, item) => {
            return acc + item.uploadUrlData?.fileToUpload?.size;
          }, 0),
      );
    }
    setUploadFilesLength(totalFilesLength);
    uploadFilesRef.current.length = 0;
    fileProgress.current = { files: {}, totalSize: 0, xhrs: [] };
  };

  return (
    <div className="form-group">
      <Dropzone
        onDrop={(acceptedFiles) => uploadFiles(acceptedFiles)}
        accept={acceptFileType}
        multiple={component === "sound" || component === "thumbnailLogo" ? false : true}
        disabled={uploading}
      >
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone modal-dropzone">
            <div className="dropzone-inner" {...getRootProps()}>
              <input {...getInputProps()} />
              <div className="upload-container-body">
                <div className="uploadClip-title">
                  <UploadIconBorder /> Drop your files here to upload or
                </div>
                {/* <div className="uploadClip-subtitle"></div> */}
                <div className="uploadclip-inside-link">Choose files</div>
              </div>
              {_.isEmpty(isMaxSizeShowMessage) ? (
                <div className="uploadClip-subtitle">File must not be larger than {uploadingFileSize} MB.</div>
              ) : (
                <div className="uploadClip-subtitle" style={{ color: "red" }}>
                  {isMaxSizeShowMessage.message}
                </div>
              )}
              <div className="uploader-progress-container">
                <Progress strokeLinecap="round" type="line" percent={progress} /> {progress > 1 ? `${progress} %` : ""}
              </div>
            </div>
          </div>
        )}
      </Dropzone>
    </div>
  );
}

export default PreSignedUpload;
